import React from 'react';
import PropTypes from 'prop-types';

class CollapsableSidebar extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    open: PropTypes.bool
  }


  static defaultProps = {
    onClose: ()=>{},
    open: false
  }

  state = {
    contentWidth: 0,
    width: 0,
    height: 0,
    open: false
  }

  constructor(...params) {
    super(...params);
    this.containerRef = React.createRef();
    this.sizeRef = React.createRef();
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.setMutationObserver();
    this.updateWindowDimensions();
    window.addEventListener('scroll', this.scrollBreak);
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    this.observer.disconnect();
    window.removeEventListener('scroll', this.scrollBreak);
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  scrollBreak = () => {
    if (this.props.open !== null) {
      this.props.onClose();
    }
  }

  setMutationObserver = () => {
    this.observer = new MutationObserver(this.setWidth);
    this.observer.observe(this.sizeRef.current, {
      attributes: true,
      childList: true,
      subtree: true
    });

    this.setWidth();
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  setWidth = () => {
    if (this.sizeRef.current) {
      const { width } = this.sizeRef.current.getBoundingClientRect();
      this.setState({
        contentWidth: width
      });
    }
  }

  get overlayStyle () {
    if (this.containerRef && this.containerRef.current) {
      const { top, left } = this.containerRef.current.getBoundingClientRect();
      if (top > 0) {
        return {
          top: `${top}px`,
          left: `${left}px`,
          right: 0,
        };
      } else {
        return {
          top: 0,
          left: `${left}px`,
          right: 0,
          bottom: 0
        };
      }
    }
    return {};
  }

  get sideBarStyle () {
    if (this.containerRef && this.containerRef.current) {
      const { top } = this.containerRef.current.getBoundingClientRect();
      if (top > 0) {
        return {
          top: 0,
          left: 0
        };
      } else {
        return {
          top: `${Math.abs(top)}px`,
          left: 0,
        };
      }
    }
    return {};
  }

  render() {
    return (
      <div ref={this.containerRef} className={['collapsable-sidebar-container', this.props.open?'open':''].filter(c=>c).join(' ')}>
        <div style={{width:this.props.open?`${this.state.contentWidth}px`:0}} className="collapsable-sidebar-inner">
          <div ref={this.sizeRef} className="collapsable-sidebar-content" style={this.sideBarStyle}>
            { this.props.children }
          </div>
        </div>
        <div onClick={this.props.onClose} className="collapsable-sidebar-overlay" style={this.overlayStyle} />
      </div>
    );
  }
}

export default CollapsableSidebar;
